module.exports = __webpack_public_path__ + "static/media/зерносушарка-інпрофіт.fe0aaeb9.jpg";